//#region Styles
import {
    Container  
} from "./styles";
import { StyleInput } from "components/CustomCheckbox/styles";
//#endregion

const EventGraphicOption = ({
    title, 
    src, 
    onClick, 
    selected,
    error = false
}) => {
    const getClassName = () => {
        const classList = [];
        error && classList.push("error");
        selected && classList.push("selected");
        return classList.join(" ");
    }
    return (
        <Container 
            onClick={onClick}
            className={getClassName()}>
            <figure>
                <StyleInput 
                    type="checkbox" 
                    checked={selected}
                    onChange={onClick}/>
                <img 
                    src={src} 
                    alt={title}/>
            </figure>
            <span>{title}</span>
        </Container>
    );
}

export default EventGraphicOption;